import React, { ReactNode } from 'react'

import * as Styled from './Link.styled'

type Props = {
  href?: string
  target?: string
  rel?: string
  children: ReactNode
  onClick?: () => void
}

const Link = ({ children, href, onClick }: Props) => {
  return (
    <Styled.Link onClick={onClick} href={href} target="_blank" rel="nofollow noopener">
      {children}
    </Styled.Link>
  )
}

export default Link
